import {
  LEAD_BUTTON_CLICKED,
  LEAD_FROM_TARIFS_BUTTON_CLICKED,
} from "./constants";
import { ClickInfo } from "./types";

/**
 * Returns the appropriate event name based on the use-case
 * for further analysis down the road (e.g. with Meta)
 */
const getNewAccountEventName = (link: string, clickInfo: ClickInfo) => {
  const {
    fromLocation
  } = clickInfo;

  const { pathname } = fromLocation || {};
  const isTarifsPage = pathname === '/tarifs' || pathname?.startsWith('/tarifs/');

  return isTarifsPage ? LEAD_FROM_TARIFS_BUTTON_CLICKED : LEAD_BUTTON_CLICKED;
};

export { getNewAccountEventName };
